import ecocampingLui from "@/assets/ecocampinglui.jpg";
import castillete from "@/assets/castillete.jpg";
import campingcabo from "@/assets/campingcabo.avif";
import playaBrava from "@/assets/tayrona-extra1.avif";
import amanecerTayrona from "@/assets/tayrona-extra2.avif";
import campingDonPedro from "@/assets/tayrona-extra3.avif";
import ecohábsTequendama from "@/assets/ecohabs_tequendama.webp";
import campingJacobo from "@/assets/camping_jacobo_tayrona.jpg";
import { CAMPING_YEAR } from "@/constants";

interface CampingSite {
  id: string;
  name: string;
  address: string;
  ratingTripAdvisor: number | null;
  ratingGoogle: number | null;
  description: string;
  amenities: string[];
  /**
   * Only numbers confirmed on the business's own website or its claimed
   * Google Business Profile (checked 2026-10-06, source noted per site).
   * Leave undefined when the official channels disagree or can't be checked.
   */
  phone?: string;
  mainUrl: string;
  mainImage: string;
  /** Descriptive alt text for mainImage — describes the photo, not just the business name. */
  imageAlt: string;
  featured?: boolean;
}

const campingSites: CampingSite[] = [
  {
    id: "1",
    name: "Camping Castilletes Parque Tayrona",
    address: "Parque Nacional Tayrona, a 3.5km de la entrada principal sector el Zaino.",
    ratingTripAdvisor: 2.8,
    ratingGoogle: 4.2,
    description:
      "Castilletes dispone de wifi gratis, piscina al aire libre, jardín y restaurante. Para mayor comodidad, el alojamiento puede ofrecer toallas y ropa de cama por un suplemento. En el camping se sirve un desayuno americano. Se puede practicar senderismo en los alrededores. Playa Castilletes está a pocos pasos del alojamiento, y Quinta de San Pedro Alejandrino está a 37 km. El aeropuerto (Aeropuerto Simón Bolívar) está a 50 km, y el alojamiento ofrece servicio de traslado de pago para ir o volver del aeropuerto.",
    amenities: [
      "Parking gratis",
      "WiFi gratis",
      "Piscina",
      "Restaurante",
      "Disponible solo para huéspedes",
      "Eventos y Cena romántica",
      "Con previa reserva y especificaciones",
      "Camping",
      "Zona de camping frente al mar",
    ],
    phone: "573196152352", // castilletesparquetayrona.com
    mainUrl: "https://www.castilletesparquetayrona.com/",
    mainImage: castillete,
    imageAlt: "Piscina y zona de camping de Camping Castilletes Parque Tayrona, cerca de playa Castilletes",
  },
  {
    id: "2",
    name: "Ecohabs Tequendama - Parque Tayrona",
    address: "Parque Nacional Tayrona 470001 Santa Marta",
    ratingTripAdvisor: 3.7,
    ratingGoogle: 4.1,
    description:
      "¡Bienvenido a Ecohabs Tequendama - Parque Tayrona! Tu puerta de entrada a un paraíso en la costa caribeña de Colombia. Aquí, donde la selva se encuentra con el mar, te espera una experiencia única de eco-alojamiento. Descubre nuestras cabañas y nuestras ecohabs perfectamente integradas en la naturaleza, a pasos de las playas más hermosas, y si buscas una conexión aún más cercana con la naturaleza, también ofrecemos opciones de camping.",
    amenities: [
      "Servicio de SPA",
      "Restaurante",
      "BBQ en la playa",
      "Jardín",
      "Masajes",
      "Parqueadero",
      "Lavandería",
      "Artículos de aseo",
      "Vistas al mar",
      "WiFi gratis",
      "Minibar",
      "Cafetera",
      "Traslado",
      "No fumadores",
      "TV",
    ],
    phone: "573209215393", // hotelestequendama.com.co/contacto.html
    mainUrl: "https://www.hotelestequendama.com.co/ecohabs-tequendama.html",
    mainImage: ecohábsTequendama,
    imageAlt: "Cabañas ecológicas de Ecohabs Tequendama entre la selva y el mar en el Parque Tayrona",
  },
  {
    id: "3",
    name: "Hotel Playa Brava Teyumakke",
    address: "Parque Nacional Tayrona 470001 Santa Marta",
    ratingTripAdvisor: 4.2,
    ratingGoogle: 4.5,
    description:
      "El Ecolodge Playa Brava Teyumakke ofrece alojamiento en Santa Marta. El establecimiento alberga un restaurante. Este albergue cuenta con mesa de ping pong. El Ecolodge Playa Brava Teyumakke se encuentra a 30 km de la playa de El Rodadero y a 24 km de la Quinta de San Pedro Alejandrino. El aeropuerto internacional Simón Bolívar, el más cercano, está a 36 km.",
    amenities: [
      "Piscina",
      "Traslado aeropuerto",
      "WiFi gratis",
      "Restaurante",
      "Situado frente a la playa",
      "Habitaciones familiares",
      "Zona privada de playa",
      "Muy buen desayuno",
    ],
    phone: "573152300818", // claimed Google Business Profile
    mainUrl:
      "https://www.tripadvisor.es/Hotel_Review-g1600802-d8091002-Reviews-Ecolodge_Playa_Brava_Teyumakke-Tayrona_National_Park_Santa_Marta_Municipality_Magdale.html",
    mainImage: playaBrava,
    imageAlt: "Alojamiento frente a la playa del Ecolodge Playa Brava Teyumakke en el Parque Tayrona",
  },
  {
    id: "4",
    name: "Eco Hotel Amanecer Tayrona",
    address: "Kilómetro 31 Parque tayrona, 400007 Zaino, Colombia.",
    ratingTripAdvisor: 5,
    ratingGoogle: 3.7,
    description:
      "Eco Hotel Amanecer Tayrona tiene vistas al jardín y está en Zaino. Cuenta con restaurante, servicio de habitaciones, bar, jardín, piscina al aire libre abierta todo el año y terraza. El camping ofrece wifi y parking privado, ambos gratis. Hay una zona de estar y de comedor en todas las unidades. En Eco Hotel Amanecer Tayrona se puede disfrutar de un desayuno americano. Se puede practicar senderismo en los alrededores.",
    amenities: [
      "Piscina",
      "WiFi gratis",
      "Parking gratis",
      "Traslado aeropuerto",
      "Servicio de habitaciones",
      "Restaurante",
      "Habitaciones sin humo",
      "Habitaciones familiares",
      "Bar",
      "Muy buen desayuno",
    ],
    phone: "573107032076", // hotelamanecertayrona.com + Google profile
    // ecohotelamanecertayrona.com is a parked domain that redirects to ads.
    mainUrl: "https://hotelamanecertayrona.com/",
    mainImage: amanecerTayrona,
    imageAlt: "Piscina y terraza con jardín del Eco Hotel Amanecer Tayrona en Zaino, Parque Tayrona",
  },
  {
    id: "5",
    name: "Camping Don Pedro",
    address: "Parque Nacional Tayrona 470001 Santa Marta",
    ratingTripAdvisor: 2.9,
    ratingGoogle: null,
    description:
      "En las estribaciones del Parque Nacional Tayrona se encuentra un tesoro en la zona de Arrecifes se llama Camping y Cabañas Don Pedro se complace en darles la Bienvenida a nuestro Complejo Turístico , dónde le brindaremos los mejores servicios en atención, alojamiento, restaurante, tienda, zona de esparcimiento y recreativos. Nuestro alojamiento queda en la zona interna y céntrica del Parque Nacional Tayrona, por lo tanto desde Don Pedro puedes caminar 15 a 20 min hasta la primera playa llamada Arenilla, a 15 minutos más está la Piscina, y a tan solo 45 minutos más está Cabo San Juan.",
    amenities: [
      "Baños",
      "Camping",
      "Cabañas",
      "Hamacas",
      "Cocina",
      "Lockers",
      "Lavadero",
      "Restaurante",
      "Energía",
      "Wifi",
    ],
    // No phone: Google shows 311 423 0541, its own site shows 300 235 9265
    // and WhatsApp 320 444 0714. Official channels disagree (2026-10-06).
    mainUrl: "https://www.campingdonpedro.com/",
    mainImage: campingDonPedro,
    imageAlt: "Zona de camping y cabañas de Camping Don Pedro en el sector Arrecifes del Parque Tayrona",
  },
  {
    id: "6",
    name: "Camping Jacobo Bermúdez",
    address: "Sector Arrecife, dentro del Parque Tayrona",
    ratingTripAdvisor: null,
    ratingGoogle: 4.3,
    description:
      "El Camping Jacobo Bermúdez tiene presencia en el Parque Tayrona desde el 15 de Febrero de 1929, habitando las tierras de Arrecife. Somos los últimos nativos ancestrales descendientes de los indígenas de Taganga. Después de que el estado Colombiano considerara estas tierras como Parque Nacional Natural en 1964, prohibió nuestras actividades agrícolas, pero delimitó la zona norte para actividades turísticas. Nosotros, en busca de una nueva forma de subsistir, decidimos reinventarnos y crear con nuestras propias manos un lugar acogedor, ecológico, consciente y amigable con el medio ambiente, en el que se preserve la naturaleza.",
    amenities: [
      "Baños",
      "Restaurante",
      "Cabañas",
      "Opción de desayuno incluido",
      "Duchas Familiares",
      "WiFi",
      "Lavadero",
      "Energía Solar",
    ],
    phone: "573014910139", // campingjacobotayrona.com (WhatsApp + schema)
    mainUrl: "https://campingjacobotayrona.com/en",
    mainImage: campingJacobo,
    imageAlt: "Cabañas y zona de camping de Camping Jacobo Bermúdez en el sector Arrecife del Parque Tayrona",
    featured: true,
  },
  {
    id: "7",
    name: "Eco-Glamping (EcoCamping LUI)",
    address: "Parque Tayrona, Sendero de 9 Piedras, Santa Marta, Magdalena, Colombia",
    ratingTripAdvisor: 3.3,
    ratingGoogle: null,
    description:
      "Hospedaje Dentro del Parque Tayrona, Sector Arrecifes EcoCarpas, Hamacas y Zona Camping. Ven y disfruta en pareja, con tu familia o un grupo de amigos,  de un lugar ecológico, encantador, tranquilo, maravilloso y rodeado de naturaleza virgen. Contamos con alojamientos en cabañas construidas de manera artesanal dentro de la preservación ambiental. Su estadía se da en diferentes tipos de acomodaciones.",
    amenities: ["EcoCarpas", "Hamacas", "Camping"],
    phone: "573108580295", // claimed Google profile; old 323 341 9422 was wrong
    mainUrl: "https://www.instagram.com/ecocampinglui/?hl=es",
    mainImage: ecocampingLui,
    imageAlt: "Carpas ecológicas y hamacas de EcoCamping LUI en el sendero de 9 Piedras, Parque Tayrona",
  },
  {
    id: "8",
    name: "Camping Cabo San Juan",
    address: "Parque Nacional Tayrona 470001 Santa Marta",
    ratingTripAdvisor: null,
    ratingGoogle: 3.6,
    description:
      "Es un lugar popular para los entusiastas de los campamentos y los amantes de la naturaleza, debido a sus impresionantes playas y exuberante vegetación. Este se encuentra ubicado a dos horas de caminata desde el parqueadero principal por un sendero panorámico que serpentea a través de la selva y a lo largo de la costa, esta caminata puede ser un desafío en algunas áreas, por lo que es importante traer zapatos resistentes y agua. En general, cabo san juan es un hermoso lugar y destino para acampar y contamos con los siguientes servicios:",
    amenities: ["Baños", "Cabañas", "Camping", "Hamacas", "Lavadero", "WiFi", "Energia con Generador"],
    // No phone: only on cabosanjuantravel.co, which can't be proven official.
    mainUrl: "https://www.instagram.com/cabosanjuandelguia/",
    mainImage: campingcabo,
    imageAlt: "Carpas de camping frente al mar en Camping Cabo San Juan, Parque Tayrona",
  },
];

// Campground structured data (JSON-LD) for the 8 sites listed above, drawn
// from the same campingSites data used to render the cards so schema and
// visible content can't drift apart. Rendered directly in JSX (rather than
// injected via useEffect) so it's present in the prerendered/SSR HTML too,
// not only after client-side hydration.
function buildCampingSitesJsonLd() {
  const graph = campingSites.map((site) => {
    const entry: Record<string, unknown> = {
      "@context": "https://schema.org",
      "@type": "Campground",
      name: site.name,
      address: {
        "@type": "PostalAddress",
        addressLocality: "Santa Marta",
        addressRegion: "Magdalena",
        addressCountry: "CO",
        streetAddress: site.address,
      },
      description: site.description,
    };
    if (site.phone) entry.telephone = `+${site.phone}`;
    if (site.mainUrl) entry.url = site.mainUrl;
    // Note: aggregateRating is intentionally omitted. site.ratingGoogle /
    // site.ratingTripAdvisor are third-party platform ratings we didn't
    // collect ourselves — averaging them into a single ratingValue would
    // fabricate a number that appears on neither platform, and using
    // third-party ratings in aggregateRating schema is outside Google's
    // review-snippet guidelines anyway.
    return entry;
  });
  return JSON.stringify(graph);
}

/** At most this many amenity chips per card (the first ones in the data). */
const AMENITIES_MAX = 5;

/**
 * Campsite cards (DESIGN.md, quiet version): photo with the featured badge
 * and rating pills, name, description, up to AMENITIES_MAX
 * amenities as one text line, address, and a text link. No phones on the
 * cards (her call, 2026-10-06); verified numbers stay in the JSON-LD.
 */
const CampingSites = () => {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: buildCampingSitesJsonLd() }}
      />
      <section id="campsites" aria-labelledby="campsites-h" className="pq-section">
        <div className="pq-wrap" style={{ display: "grid", gap: 48 }}>
          <div style={{ display: "grid", gap: 16 }}>
            <h2 id="campsites-h" className="pq-headline">
              Campings en el Parque Tayrona: guía local {CAMPING_YEAR}.
            </h2>
            <p className="pq-lead">
              Desde Cabo San Juan hasta Arrecifes: los campamentos verificados del
              Parque Nacional Natural Tayrona con servicios, contacto y cómo
              reservar en {CAMPING_YEAR}.
            </p>
          </div>

          <ul className="pq-camps">
            {campingSites.map((site) => {
              return (
                <li key={site.id} className="pq-camp">
                  <div className="pq-camp-img">
                    <img
                      src={site.mainImage}
                      alt={site.imageAlt}
                      loading="lazy"
                      decoding="async"
                    />
                    <div className="pq-camp-badges">
                      {site.featured ? (
                        <span className="pq-chip pq-chip-ink">Recomendado</span>
                      ) : null}
                      {site.ratingGoogle ? (
                        <span className="pq-chip pq-chip-frost">Google {site.ratingGoogle}</span>
                      ) : null}
                      {site.ratingTripAdvisor ? (
                        <span className="pq-chip pq-chip-frost">TripAdvisor {site.ratingTripAdvisor}</span>
                      ) : null}
                    </div>
                  </div>

                  <div className="pq-camp-body">
                    <h3 className="pq-title">{site.name}</h3>
                    <p className="pq-small">{site.description}</p>
                    <p className="pq-meta">
                      {site.amenities.slice(0, AMENITIES_MAX).join(" · ")}
                    </p>
                    <p className="pq-meta">{site.address}</p>
                    <a
                      href={site.mainUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="pq-link pq-camp-link"
                    >
                      Ver disponibilidad
                      <span aria-hidden="true"> ↗</span>
                      <span className="pq-sr"> de {site.name} (abre en una pestaña nueva)</span>
                    </a>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </section>
    </>
  );
};

export default CampingSites;
